(function () {
  var PER_PAGE = 20;
  var PARAM_FORMAT = 'loh_format';
  var PARAM_ARTIST = 'loh_artist';

  var allItems = [];
  var filteredItems = [];
  var activeFormats = new Set();
  var activeArtist = '';
  var activeSort = 'created-descending';
  var currentPage = 1;

  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    allItems = Array.from(grid.querySelectorAll('li[data-formats]'));
    if (!allItems.length) return;

    readUrlState();
    buildFormatButtons();
    buildArtistSelect();
    setupSort();
    setupClearButton();
    setupPagination();
    syncClearButton();
    applyFilters(false);
  }

  function artistSortKey(name) {
    return name.replace(/^the\s+/i, '').toLowerCase();
  }

  function readUrlState() {
    var params = new URLSearchParams(window.location.search);
    var fmts = (params.get(PARAM_FORMAT) || '').split(',').filter(Boolean);
    fmts.forEach(function (f) { activeFormats.add(f); });
    activeArtist = params.get(PARAM_ARTIST) || '';
  }

  function updateUrl() {
    var params = new URLSearchParams(window.location.search);
    if (activeFormats.size > 0) {
      params.set(PARAM_FORMAT, Array.from(activeFormats).join(','));
    } else {
      params.delete(PARAM_FORMAT);
    }
    if (activeArtist) {
      params.set(PARAM_ARTIST, activeArtist);
    } else {
      params.delete(PARAM_ARTIST);
    }
    history.replaceState(null, '', '?' + params.toString());
  }

  // Which formats exist on items matching the current artist filter?
  function getFormatsForCurrentArtist() {
    var available = new Set();
    allItems.forEach(function (item) {
      var itemArtists = (item.dataset.artist || '').split('|').map(function (a) { return a.trim(); }).filter(Boolean);
      var artistMatch = !activeArtist || itemArtists.indexOf(activeArtist) !== -1;
      if (artistMatch) {
        (item.dataset.formats || '').split(' ').filter(Boolean).forEach(function (f) { available.add(f); });
      }
    });
    return available;
  }

  // Which artists exist on items matching the current format filter?
  function getArtistsForCurrentFormats() {
    var available = new Set();
    allItems.forEach(function (item) {
      var fmts = new Set((item.dataset.formats || '').split(' ').filter(Boolean));
      var fmtMatch = activeFormats.size === 0 || Array.from(activeFormats).some(function (f) { return fmts.has(f); });
      if (fmtMatch) {
        (item.dataset.artist || '').split('|').forEach(function (a) {
          a = a.trim();
          if (a) available.add(a);
        });
      }
    });
    return available;
  }

  function updateAvailableFilters() {
    var availableFormats = getFormatsForCurrentArtist();
    var availableArtists = getArtistsForCurrentFormats();

    document.querySelectorAll('.loh-filter-btn[data-format]').forEach(function (btn) {
      btn.disabled = !availableFormats.has(btn.dataset.format);
    });

    var artistSelect = document.getElementById('loh-artist-select');
    if (!artistSelect) return;
    var current = artistSelect.value;
    while (artistSelect.options.length > 1) artistSelect.remove(1);
    Array.from(availableArtists).sort(function (a, b) { return artistSortKey(a).localeCompare(artistSortKey(b)); }).forEach(function (artist) {
      var opt = document.createElement('option');
      opt.value = artist;
      opt.textContent = artist;
      artistSelect.appendChild(opt);
    });
    if (availableArtists.has(current)) {
      artistSelect.value = current;
    } else if (current) {
      activeArtist = '';
      artistSelect.value = '';
    }
  }

  function buildFormatButtons() {
    var container = document.getElementById('loh-format-filters');
    if (!container) return;
    var counts = { vinyl: 0, cd: 0, cassette: 0, digital: 0 };
    allItems.forEach(function (item) {
      (item.dataset.formats || '').split(' ').filter(Boolean).forEach(function (f) {
        if (f in counts) counts[f]++;
      });
    });
    var labels = { vinyl: 'Vinyl', cd: 'CD', cassette: 'Cassette', digital: 'Digital' };
    ['vinyl', 'cd', 'cassette', 'digital'].forEach(function (fmt) {
      if (!counts[fmt]) return;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'loh-filter-btn';
      btn.dataset.format = fmt;
      btn.textContent = labels[fmt];
      if (activeFormats.has(fmt)) btn.classList.add('is-active');
      btn.addEventListener('click', function () {
        if (activeFormats.has(fmt)) {
          activeFormats.delete(fmt);
          btn.classList.remove('is-active');
        } else {
          activeFormats.add(fmt);
          btn.classList.add('is-active');
        }
        currentPage = 1;
        updateUrl();
        applyFilters(false);
        syncClearButton();
      });
      container.appendChild(btn);
    });
  }

  function buildArtistSelect() {
    var select = document.getElementById('loh-artist-select');
    if (!select) return;
    var artists = new Set();
    allItems.forEach(function (item) {
      (item.dataset.artist || '').split('|').forEach(function (a) {
        a = a.trim();
        if (a) artists.add(a);
      });
    });
    Array.from(artists).sort(function (a, b) { return artistSortKey(a).localeCompare(artistSortKey(b)); }).forEach(function (artist) {
      var opt = document.createElement('option');
      opt.value = artist;
      opt.textContent = artist;
      select.appendChild(opt);
    });
    if (activeArtist) select.value = activeArtist;
    select.addEventListener('change', function () {
      activeArtist = select.value;
      currentPage = 1;
      updateUrl();
      applyFilters(false);
      syncClearButton();
    });
  }

  function setupSort() {
    var select = document.getElementById('loh-sort-select');
    if (!select) return;
    activeSort = select.value || 'created-descending';
    select.addEventListener('change', function () {
      if (select.value === 'best-selling') {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', 'best-selling');
        if (activeFormats.size > 0) params.set(PARAM_FORMAT, Array.from(activeFormats).join(','));
        else params.delete(PARAM_FORMAT);
        if (activeArtist) params.set(PARAM_ARTIST, activeArtist);
        else params.delete(PARAM_ARTIST);
        window.location.href = window.location.pathname + '?' + params.toString();
        return;
      }
      activeSort = select.value;
      currentPage = 1;
      applyFilters(false);
    });
  }

  function sortItems(items) {
    return items.slice().sort(function (a, b) {
      switch (activeSort) {
        case 'title-ascending':
          return (a.dataset.title || '').localeCompare(b.dataset.title || '');
        case 'title-descending':
          return (b.dataset.title || '').localeCompare(a.dataset.title || '');
        case 'price-ascending':
          return parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0);
        case 'price-descending':
          return parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0);
        case 'created-ascending':
          return parseFloat(a.dataset.date || 0) - parseFloat(b.dataset.date || 0);
        case 'created-descending':
          return parseFloat(b.dataset.date || 0) - parseFloat(a.dataset.date || 0);
        default:
          return parseFloat(a.dataset.position || 0) - parseFloat(b.dataset.position || 0);
      }
    });
  }

  function setupClearButton() {
    var btn = document.getElementById('loh-filter-clear');
    if (!btn) return;
    btn.addEventListener('click', function () {
      activeFormats.clear();
      activeArtist = '';
      currentPage = 1;
      document.querySelectorAll('.loh-filter-btn.is-active').forEach(function (b) { b.classList.remove('is-active'); });
      var select = document.getElementById('loh-artist-select');
      if (select) select.value = '';
      updateUrl();
      applyFilters(false);
      syncClearButton();
    });
  }

  function setupPagination() {
    var container = document.getElementById('loh-pagination');
    if (!container) return;
    container.innerHTML =
      '<button type="button" id="loh-prev" class="loh-pagination__btn">← Prev</button>' +
      '<span id="loh-page-info" class="loh-pagination__info"></span>' +
      '<button type="button" id="loh-next" class="loh-pagination__btn">Next →</button>';
    document.getElementById('loh-prev').addEventListener('click', function () {
      if (currentPage > 1) { currentPage--; renderPage(true); }
    });
    document.getElementById('loh-next').addEventListener('click', function () {
      if (currentPage < totalPages()) { currentPage++; renderPage(true); }
    });
  }

  function applyFilters(scroll) {
    filteredItems = sortItems(allItems.filter(function (item) {
      var fmts = new Set((item.dataset.formats || '').split(' ').filter(Boolean));
      var itemArtists = (item.dataset.artist || '').split('|').map(function (a) { return a.trim(); }).filter(Boolean);
      var fmtMatch = activeFormats.size === 0 || Array.from(activeFormats).some(function (f) { return fmts.has(f); });
      var artistMatch = !activeArtist || itemArtists.indexOf(activeArtist) !== -1;
      return fmtMatch && artistMatch;
    }));
    updateAvailableFilters();
    renderPage(scroll);
  }

  function renderPage(scroll) {
    var start = (currentPage - 1) * PER_PAGE;
    var pageSet = new Set(filteredItems.slice(start, start + PER_PAGE));
    allItems.forEach(function (item) {
      item.style.display = pageSet.has(item) ? '' : 'none';
    });
    var pages = totalPages();
    var prevBtn = document.getElementById('loh-prev');
    var nextBtn = document.getElementById('loh-next');
    var info = document.getElementById('loh-page-info');
    var paginationEl = document.getElementById('loh-pagination');
    if (prevBtn) prevBtn.disabled = currentPage <= 1;
    if (nextBtn) nextBtn.disabled = currentPage >= pages;
    if (info) {
      if (!filteredItems.length) {
        info.textContent = 'No results';
      } else if (pages > 1) {
        info.textContent = 'Page ' + currentPage + ' of ' + pages;
      } else {
        info.textContent = filteredItems.length + ' release' + (filteredItems.length !== 1 ? 's' : '');
      }
    }
    if (paginationEl) {
      paginationEl.removeAttribute('hidden');
      paginationEl.style.display = pages > 1 ? '' : 'none';
    }
    if (scroll) {
      var grid = document.getElementById('product-grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function totalPages() {
    return Math.max(1, Math.ceil(filteredItems.length / PER_PAGE));
  }

  function syncClearButton() {
    var btn = document.getElementById('loh-filter-clear');
    if (!btn) return;
    if (activeFormats.size > 0 || activeArtist) {
      btn.removeAttribute('hidden');
    } else {
      btn.setAttribute('hidden', '');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
